/* Ensure body overflow-hidden (from loader) is removed so position:sticky works */
(function () {
  if (!document.querySelector('.pp-main-product')) return;
  document.body.classList.remove('overflow-hidden');
  void document.body.offsetHeight;
})();

/* ── Cart-drawer helpers ── */
function ppOpenDrawer(drawer) {
  if (!drawer) drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  try { if (typeof drawer.open === 'function') { drawer.open(); return; } } catch (e) { /* fall through */ }
  setTimeout(function () { drawer.classList.add('animate', 'active'); });
  document.body.classList.add('overflow-hidden');
}

function ppCloseDrawer(drawer) {
  if (!drawer) drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  try { if (typeof drawer.close === 'function') { drawer.close(); return; } } catch (e) { /* fall through */ }
  drawer.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}

/* Shared add-to-cart that opens the cart drawer (used by cross-sell + sticky bar) */
window.ppAddToCart = function (variantId, btn) {
  if (btn) btn.disabled = true;
  var cartDrawer = document.querySelector('cart-drawer');
  var sections = 'cart-drawer,cart-icon-bubble,cart-reminder';
  try {
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }
  } catch (e) { /* ignore */ }
  var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
  if (!/\.js($|\?)/.test(addUrl)) addUrl = addUrl + '.js';

  fetch(addUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { if (btn) btn.disabled = false; return; }
      if (!cartDrawer) {
        if (btn) btn.disabled = false;
        return;
      }

      fetch(window.location.pathname + '?sections=' + encodeURIComponent(sections))
        .then(function (res) { return res.json(); })
        .then(function (sectionsResponse) {
          if (!sectionsResponse || typeof sectionsResponse !== 'object') return;
          var syntheticState = {
            id: data.id || variantId,
            sections: sectionsResponse
          };
          cartDrawer.renderContents(syntheticState);
        })
        .catch(function () { /* ignore */ })
        .finally(function () {
          if (btn) {
            var origFallback = btn.innerHTML;
            btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            setTimeout(function () { btn.innerHTML = origFallback; btn.disabled = false; }, 1500);
          }
        });
    })
    .catch(function () { if (btn) btn.disabled = false; });
};

if (!customElements.get('premium-product-gallery')) {
  customElements.define(
    'premium-product-gallery',
    class PremiumProductGallery extends HTMLElement {
      constructor() {
        super();
        this.viewport = this.querySelector('.pp-gallery__slides');
        this.slides = Array.from(this.querySelectorAll('.pp-gallery__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.pp-gallery__thumb'));
        this.onScroll = this.onScroll.bind(this);
        this.onViewportClick = this.onViewportClick.bind(this);
        this.prevButton = this.querySelector('[data-gallery-prev]');
        this.nextButton = this.querySelector('[data-gallery-next]');
        this.currentCounter = this.querySelector('[data-gallery-current]');
        this.totalCounter = this.querySelector('[data-gallery-total]');
        this.zoom_listeners = [];
        this.lightbox = null;
        this.lightbox_on_keydown = null;
      }

      connectedCallback() {
        if (!this.viewport || !this.slides.length) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.setActiveMedia(thumb.dataset.target, true);
          });
        });

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.step(-1));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.step(1));
        }

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('click', this.onViewportClick);
        this.bindDesktopZoom();
        this.setInitialActive();
      }

      disconnectedCallback() {
        if (this.viewport) {
          this.viewport.removeEventListener('scroll', this.onScroll);
          this.viewport.removeEventListener('click', this.onViewportClick);
        }

        this.zoom_listeners.forEach((unbind) => {
          if (typeof unbind === 'function') unbind();
        });
        this.zoom_listeners = [];
        this.closeLightbox(false);
      }

      setInitialActive() {
        const active_slide = this.querySelector('.pp-gallery__slide.is-active') || this.getVisibleSlides()[0] || this.slides[0];
        if (active_slide) {
          this.setActiveMedia(active_slide.dataset.mediaId, false);
        }
      }

      onScroll() {
        if (window.matchMedia('(min-width: 990px)').matches) {
          return;
        }

        const scroll_padding = parseFloat(getComputedStyle(this.viewport).scrollPaddingInlineStart) || 0;
        const snap_target = this.viewport.scrollLeft + scroll_padding;
        const visibleSlides = this.getVisibleSlides();
        let closest_slide = visibleSlides[0];
        let closest_offset = Number.POSITIVE_INFINITY;

        visibleSlides.forEach((slide) => {
          const offset = Math.abs(slide.offsetLeft - snap_target);
          if (offset < closest_offset) {
            closest_offset = offset;
            closest_slide = slide;
          }
        });

        if (closest_slide) {
          this.updateActiveState(closest_slide.dataset.mediaId);
        }
      }

      setActiveMedia(media_id, smooth_scroll = true) {
        const active_slide = this.querySelector(`[data-media-id="${media_id}"]`);
        if (!active_slide) return;

        this.updateActiveState(media_id);

        const is_mobile = window.matchMedia('(max-width: 989px)').matches;
        let target_left;
        if (is_mobile) {
          const scroll_padding = parseFloat(getComputedStyle(this.viewport).scrollPaddingInlineStart) || 0;
          target_left = active_slide.offsetLeft - scroll_padding;
        } else {
          target_left = active_slide.offsetLeft - Math.max((this.viewport.clientWidth - active_slide.clientWidth) / 2, 0);
        }
        this.viewport.scrollTo({ left: target_left, behavior: smooth_scroll ? 'smooth' : 'auto' });

        const deferred_media = active_slide.querySelector('.deferred-media');
        if (deferred_media && deferred_media.loadContent) {
          deferred_media.loadContent(false);
        }
      }

      step(direction) {
        const visibleSlides = this.getVisibleSlides();
        if (!visibleSlides.length) return;
        const activeIndex = visibleSlides.findIndex((slide) => slide.classList.contains('is-active'));
        const currentIndex = activeIndex === -1 ? 0 : activeIndex;
        const nextIndex = (currentIndex + direction + visibleSlides.length) % visibleSlides.length;
        this.setActiveMedia(visibleSlides[nextIndex].dataset.mediaId);
      }

      updateActiveState(media_id) {
        this.slides.forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.mediaId === media_id);
        });

        this.thumbs.forEach((thumb) => {
          if (thumb.dataset.target === media_id) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });

        const visibleSlides = this.getVisibleSlides();
        const activeIndex = visibleSlides.findIndex((slide) => slide.dataset.mediaId === media_id);
        if (this.totalCounter) {
          this.totalCounter.textContent = String(visibleSlides.length || 0);
        }
        if (this.currentCounter && activeIndex !== -1) {
          this.currentCounter.textContent = String(activeIndex + 1);
        }
      }

      bindDesktopZoom() {
        this.zoom_listeners.forEach((unbind) => {
          if (typeof unbind === 'function') unbind();
        });
        this.zoom_listeners = [];

        this.slides.forEach((slide) => {
          if (slide.dataset.mediaType !== 'image') return;
          const image = slide.querySelector('.pp-media');
          if (!image) return;

          image.classList.add('pp-media--zoomable');

          const updateOrigin = (event) => {
            const rect = image.getBoundingClientRect();
            if (!rect.width || !rect.height) return;
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            image.style.setProperty('--pp-zoom-x', `${Math.min(100, Math.max(0, x))}%`);
            image.style.setProperty('--pp-zoom-y', `${Math.min(100, Math.max(0, y))}%`);
          };

          const onClick = (event) => {
            if (!window.matchMedia('(min-width: 990px)').matches) return;
            if (!slide.classList.contains('is-active')) return;
            updateOrigin(event);
            image.classList.toggle('is-zooming');
          };

          const onMouseMove = (event) => {
            if (!window.matchMedia('(min-width: 990px)').matches) return;
            if (!image.classList.contains('is-zooming')) return;
            updateOrigin(event);
          };

          const onMouseLeave = () => {
            image.classList.remove('is-zooming');
          };

          image.addEventListener('click', onClick);
          image.addEventListener('mousemove', onMouseMove);
          image.addEventListener('mouseleave', onMouseLeave);

          this.zoom_listeners.push(() => {
            image.removeEventListener('click', onClick);
            image.removeEventListener('mousemove', onMouseMove);
            image.removeEventListener('mouseleave', onMouseLeave);
          });
        });
      }

      onViewportClick(event) {
        if (!window.matchMedia('(max-width: 989px)').matches) return;

        const image = event.target.closest('.pp-gallery__slide[data-media-type="image"] .pp-media');
        if (!image) return;

        const active_slide = image.closest('.pp-gallery__slide');
        if (!active_slide || !active_slide.classList.contains('is-active')) return;

        event.preventDefault();
        this.openLightbox(active_slide.dataset.mediaId);
      }

      getLightboxItems() {
        return this.getVisibleSlides()
          .filter((slide) => slide.dataset.mediaType === 'image')
          .map((slide) => {
            const image = slide.querySelector('.pp-media');
            if (!image) return null;
            return {
              mediaId: slide.dataset.mediaId,
              src: image.currentSrc || image.src,
              alt: image.alt || ''
            };
          })
          .filter(Boolean);
      }

      openLightbox(active_media_id) {
        const items = this.getLightboxItems();
        if (!items.length) return;

        const start_index = Math.max(
          0,
          items.findIndex((item) => item.mediaId === active_media_id)
        );

        const modal = document.createElement('div');
        modal.className = 'pp-lightbox';
        modal.innerHTML = `
          <div class="pp-lightbox__overlay" data-lightbox-close></div>
          <div class="pp-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Produktbilder">
            <button type="button" class="pp-lightbox__close" data-lightbox-close aria-label="Schliessen">&times;</button>
            <div class="pp-lightbox__viewport">
              <div class="pp-lightbox__track"></div>
            </div>
            <button type="button" class="pp-lightbox__nav pp-lightbox__nav--prev" data-lightbox-prev aria-label="Vorheriges Bild">&lsaquo;</button>
            <button type="button" class="pp-lightbox__nav pp-lightbox__nav--next" data-lightbox-next aria-label="Naechstes Bild">&rsaquo;</button>
          </div>
        `;

        /* Inline fallback styles ensure the modal still renders correctly if CSS is stale/cached. */
        modal.style.position = 'fixed';
        modal.style.inset = '0';
        modal.style.zIndex = '2147483646';
        modal.style.background = 'rgba(5, 6, 8, 0.45)';
        modal.style.backdropFilter = 'blur(12px)';
        modal.style.webkitBackdropFilter = 'blur(12px)';
        modal.style.overflow = 'hidden';

        const dialog = modal.querySelector('.pp-lightbox__dialog');
        if (dialog) {
          dialog.style.position = 'relative';
          dialog.style.zIndex = '2';
          dialog.style.width = '100%';
          dialog.style.height = '100%';
          dialog.style.display = 'flex';
          dialog.style.alignItems = 'center';
          dialog.style.justifyContent = 'center';
          dialog.style.padding = 'max(1.2rem, env(safe-area-inset-top)) 1rem max(1.2rem, env(safe-area-inset-bottom))';
        }

        const viewportNode = modal.querySelector('.pp-lightbox__viewport');
        if (viewportNode) {
          viewportNode.style.width = 'min(92vw, 46rem)';
          viewportNode.style.aspectRatio = '1 / 1';
          viewportNode.style.height = 'auto';
          viewportNode.style.overflow = 'hidden';
          viewportNode.style.borderRadius = '1.8rem';
          viewportNode.style.border = '0';
          viewportNode.style.background = 'transparent';
          viewportNode.style.boxShadow = 'none';
        }

        modal.querySelectorAll('.pp-lightbox__slide').forEach((slide) => {
          slide.style.padding = '0';
        });

        modal.querySelectorAll('.pp-lightbox__image').forEach((img) => {
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.objectFit = 'contain';
          img.style.borderRadius = '1.6rem';
        });

        modal.querySelectorAll('.pp-lightbox__nav').forEach((button) => {
          button.style.background = 'transparent';
          button.style.border = '0';
          button.style.color = '#C8A84B';
          button.style.fontSize = '4rem';
          button.style.width = '4rem';
          button.style.height = '4rem';
          button.style.touchAction = 'manipulation';
        });
        const closeBtn = modal.querySelector('.pp-lightbox__close');
        if (closeBtn) {
          closeBtn.style.background = 'transparent';
          closeBtn.style.border = '0';
          closeBtn.style.color = 'rgba(255,255,255,0.75)';
        }

        const track = modal.querySelector('.pp-lightbox__track');
        items.forEach((item) => {
          const slide = document.createElement('div');
          slide.className = 'pp-lightbox__slide';
          slide.innerHTML = `<img src="${item.src}" alt="${item.alt.replace(/"/g, '&quot;')}" class="pp-lightbox__image" loading="eager">`;
          track.appendChild(slide);
        });

        document.body.appendChild(modal);
        document.body.classList.add('overflow-hidden');

        this.lightbox = {
          modal,
          track,
          items,
          index: start_index,
          startX: 0,
          deltaX: 0
        };

        const goTo = (index) => {
          if (!this.lightbox) return;
          const total = this.lightbox.items.length;
          this.lightbox.index = (index + total) % total;
          this.lightbox.track.style.transform = `translateX(-${this.lightbox.index * 100}%)`;
        };

        const goStep = (direction) => {
          if (!this.lightbox) return;
          goTo(this.lightbox.index + direction);
        };

        goTo(start_index);

        modal.querySelectorAll('[data-lightbox-close]').forEach((node) => {
          const closeHandler = (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.closeLightbox(true);
          };

          node.addEventListener('click', closeHandler);
          node.addEventListener('pointerdown', closeHandler);
          node.addEventListener('touchstart', closeHandler, { passive: false });
        });

        modal.addEventListener('click', (event) => {
          if (!event.target.closest('.pp-lightbox__viewport') &&
              !event.target.closest('.pp-lightbox__nav') &&
              !event.target.closest('.pp-lightbox__close')) {
            this.closeLightbox(true);
          }
        });

        const prevButton = modal.querySelector('[data-lightbox-prev]');
        const nextButton = modal.querySelector('[data-lightbox-next]');
        if (prevButton) {
          prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            goStep(-1);
          });
        }
        if (nextButton) {
          nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            goStep(1);
          });
        }

        const viewport = modal.querySelector('.pp-lightbox__viewport');
        if (viewport) {
          viewport.addEventListener(
            'touchstart',
            (event) => {
              if (!this.lightbox || !event.touches[0]) return;
              this.lightbox.startX = event.touches[0].clientX;
              this.lightbox.deltaX = 0;
            },
            { passive: true }
          );

          viewport.addEventListener(
            'touchmove',
            (event) => {
              if (!this.lightbox || !event.touches[0]) return;
              this.lightbox.deltaX = event.touches[0].clientX - this.lightbox.startX;
            },
            { passive: true }
          );

          viewport.addEventListener('touchend', () => {
            if (!this.lightbox) return;
            const threshold = 42;
            if (Math.abs(this.lightbox.deltaX) < threshold) return;
            if (this.lightbox.deltaX < 0) {
              goStep(1);
            } else {
              goStep(-1);
            }
          });
        }

        this.lightbox_on_keydown = (event) => {
          if (!this.lightbox) return;
          if (event.key === 'Escape') this.closeLightbox(true);
          if (event.key === 'ArrowRight') goStep(1);
          if (event.key === 'ArrowLeft') goStep(-1);
        };
        document.addEventListener('keydown', this.lightbox_on_keydown);
      }

      closeLightbox(sync_main_gallery) {
        if (!this.lightbox) return;

        const active_item = this.lightbox.items[this.lightbox.index];
        if (this.lightbox.modal && this.lightbox.modal.parentNode) {
          this.lightbox.modal.parentNode.removeChild(this.lightbox.modal);
        }
        document.body.classList.remove('overflow-hidden');

        if (this.lightbox_on_keydown) {
          document.removeEventListener('keydown', this.lightbox_on_keydown);
          this.lightbox_on_keydown = null;
        }

        this.lightbox = null;

        if (sync_main_gallery && active_item && active_item.mediaId) {
          this.setActiveMedia(active_item.mediaId, false);
        }
      }

      getVisibleSlides() {
        return this.slides.filter((slide) => this.isElementVisible(slide));
      }

      isElementVisible(element) {
        if (!element) return false;
        return window.getComputedStyle(element).display !== 'none';
      }
    }
  );
}

if (!customElements.get('premium-sticky-cart')) {
  customElements.define(
    'premium-sticky-cart',
    class PremiumStickyCart extends HTMLElement {
      constructor() {
        super();
        this.section_id = this.dataset.section;
        this.onMutation = this.onMutation.bind(this);
        this.onViewportChange = this.onViewportChange.bind(this);
      }

      connectedCallback() {
        this.anchor = document.getElementById(this.dataset.anchor);
        this.title = this.querySelector('[data-premium-title]');
        this.variant = this.querySelector('[data-premium-variant]');
        this.price = this.querySelector('[data-premium-price]');
        this.button = this.querySelector('[data-premium-submit]');
        this.form_button = document.getElementById(`ProductSubmitButton-${this.section_id}`);
        this.price_source = document.getElementById(`price-${this.section_id}`);
        this.section_root = document.getElementById(`MainProduct-${this.section_id}`);
        this.variantSummary = document.querySelector(`#ProductInfo-${this.section_id} [data-premium-selected-variant]`);

        if (this.button) {
          this.button.addEventListener('click', () => {
            /* Get the currently selected variant id from the hidden input */
            const variantInput = document.querySelector(`#product-form-${this.section_id} input[name="id"]`);
            if (variantInput && variantInput.value) {
              window.ppAddToCart(variantInput.value, this.button);
            } else if (this.form_button) {
              this.form_button.click();
            }
          });
        }

        if ('IntersectionObserver' in window && this.anchor) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (window.matchMedia('(min-width: 990px)').matches) {
                  this.classList.remove('is-visible');
                  return;
                }
                this.classList.toggle('is-visible', !entry.isIntersecting);
              });
            },
            { threshold: 0.18 }
          );
          this.observer.observe(this.anchor);
        }

        if (this.price_source) {
          this.mutation_observer = new MutationObserver(this.onMutation);
          this.mutation_observer.observe(this.price_source, { childList: true, subtree: true, characterData: true });
        }

        if (this.section_root) {
          this.section_root.addEventListener('change', this.onMutation);
        }

        window.addEventListener('resize', this.onViewportChange);
        this.sync();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mutation_observer) this.mutation_observer.disconnect();
        if (this.section_root) this.section_root.removeEventListener('change', this.onMutation);
        window.removeEventListener('resize', this.onViewportChange);
      }

      onMutation() {
        window.requestAnimationFrame(() => this.sync());
      }

      onViewportChange() {
        if (window.matchMedia('(min-width: 990px)').matches) {
          this.classList.remove('is-visible');
        }
      }

      sync() {
        const title_source = document.querySelector(`#ProductInfo-${this.section_id} .pp-title`);
        const selected_values = Array.from(
          document.querySelectorAll(`#ProductInfo-${this.section_id} .selected__value`)
        )
          .map((node) => node.textContent.trim())
          .filter(Boolean);

        if (this.title && title_source) {
          this.title.textContent = title_source.textContent.trim();
        }

        if (this.variant) {
          this.variant.textContent = selected_values.length ? selected_values.join(' · ') : this.dataset.defaultVariant || '';
        }

        if (this.variantSummary) {
          this.variantSummary.textContent = selected_values.length ? selected_values.join(' · ') : this.dataset.defaultVariant || '';
        }

        if (this.price && this.price.nodeType === 1 && this.price_source) {
          const price_text = this.price_source.textContent.replace(/\s+/g, ' ').trim();
          this.price.textContent = price_text;
        }

        if (this.form_button && this.button) {
          this.button.disabled = this.form_button.disabled;
        }
      }
    }
  );
}

if (!customElements.get('premium-tabs')) {
  customElements.define(
    'premium-tabs',
    class PremiumTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.setActive(button.dataset.tabTarget));
        });

        const active_button = this.buttons.find((button) => button.classList.contains('is-active')) || this.buttons[0];
        if (active_button) this.setActive(active_button.dataset.tabTarget);
      }

      setActive(target_id) {
        this.buttons.forEach((button) => button.classList.toggle('is-active', button.dataset.tabTarget === target_id));
        this.panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.tabPanel === target_id));
      }
    }
  );
}

/* ── Premium template: reminder bar + ESC ── */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.querySelector('.pp-main-product')) return;
  var cd = document.querySelector('cart-drawer');
  if (!cd) return;

  document.addEventListener('click', function (e) {
    var atcButton = e.target.closest('.pp-cross-sell__atc');
    if (!atcButton) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = atcButton.dataset.variantId;
    if (!variantId) return;
    window.ppAddToCart(variantId, atcButton);
  });

  /* Reminder bar "Warenkorb anzeigen" → open drawer instead of /cart */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#cart-count-reminder a, #cart-count-reminder .button');
    if (link) { e.preventDefault(); e.stopPropagation(); ppOpenDrawer(cd); }
  }, true);

  /* ESC to close */
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && cd.classList.contains('active')) ppCloseDrawer(cd);
  });
});

/* ── Promo code copy-on-click ── */
document.addEventListener('click', function (e) {
  var el = e.target.closest('.pp-promo__code');
  if (!el || el.classList.contains('is-copied')) return;
  var code = el.textContent.trim();
  if (!code) return;
  navigator.clipboard.writeText(code).then(function () {
    el.dataset.original = code;
    el.textContent = 'Kopiert!';
    el.classList.add('is-copied');
    setTimeout(function () {
      el.textContent = el.dataset.original;
      el.classList.remove('is-copied');
    }, 1800);
  });
});